// @flow
export { default } from './FakeLetterCard';



// WEBPACK FOOTER //
// ./src/components/common/FakeLetterCard/index.js